<h1 mat-dialog-title>{{title}}</h1>
<div mat-dialog-content style="min-height: 500px; min-width: 300px;">
  <div>
    <form [formGroup]="formSearch" autocomplete="nope"
      style="width: 100%;">

      <mat-form-field style="width: 290px;">
        <mat-label>Search by County or ZIP</mat-label>
        <input matInput autocomplete="off"
          id="searchPhrase"
          name="searchPhrase"
          formControlName="searchPhrase"
          placeholder="Search by County or ZIP">
      </mat-form-field>

    </form>
  </div>

  <div *ngIf="waitForListingToShow">
    <mat-progress-bar
      value='40'
      mode='indeterminate'>
    </mat-progress-bar>
    <p>
      Loading ZIP Codes...
    </p>
  </div>

  <div style="margin-top: 15px;">
    <div>
      <div *ngIf="noSearchResults else displayListing">
        <p>No search results</p>
      </div>
    </div>

    <ng-template #displayListing>
      <div class="mat-elevation-z7">
        <table mat-table [dataSource]="dataSourceTable" style="width: 100%;">
            <ng-container matColumnDef="checkbox">
              <td mat-cell width="60px;"
                *matCellDef="let item" class="checkbox-hide-label">
                  <mat-checkbox
                    (change)="$event ? selection.toggle(item) : null"
                    [checked]="selection.isSelected(item)"
                    >{{checkboxLabel(item)}}
                  </mat-checkbox>
              </td>
            </ng-container>

            <ng-container matColumnDef="zipCode">
              <td mat-cell width="60px;"
                *matCellDef="let item">
                <span style="font-size: 12px;">
                  {{item.name}}
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="city">
              <td mat-cell
                *matCellDef="let item">
                <span style="font-size: 12px;">
                  {{item.city}}<span *ngIf="item.city && item.city.length > 0">, </span>{{item.county}}
                </span>
              </td>
            </ng-container>

          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <mat-paginator [length]="dataResultsLength" [pageSizeOptions]="tablePageSizeOptions"></mat-paginator>
      </div>
    </ng-template>
  </div>

</div>
<div mat-dialog-actions style="margin-top: 18px !important; float: right !important;">
  <button mat-button id="dialogDeleteZipCodeCancelButton"
    style="margin-right: 6px;"
    (click)="onClickCancel()">
    CANCEL
  </button>
  <button mat-stroked-button color="primary" id="dialogDeleteZipCodeSaveButton"
    type="submit" 
    (click)="onClickSave()">
    SAVE
  </button>
</div>


